import { Routing } from 'pages'
import { withProviders } from './providers'
import './styles/index.css'

const App = () => (
  <Routing />
)

export default withProviders(App)
